export default {"src":"/_next/static/image/public/images/flags/flag_31.7af4d8e1ac327c6ddfe602859266fc04.svg","height":16,"width":24};